import gql from 'graphql-tag';

const GET_WINDOWS_FROM_LOCAL = gql`
    query getWindowsFromLocal ($input: GetWindowsFromLocalInput) {
        getWindowsFromLocal (input: $input) {
            message,
            status,
            data {
                carrier,
                carrierId,
                deliveryWindows {
                    startWindow,
                    endWindow,
                    fullWindow,
                    label,
                    value,
                    availableCapacity
                }
            }
        }
    }
`;

export default GET_WINDOWS_FROM_LOCAL;
